module.exports = __webpack_public_path__ + "img/hr-V-R-4-unload-connect-shadow.da1972a3.png";